var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBranded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54205A",
    d: "M10 14h4v-4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0h4v10h-4V0zM0 10h10v4H0v-4z",
    fill: "#FC2361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4v10h-4V14zm4-4h10v4H14v-4z",
    fill: "#5CC7EA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBranded);
export default __webpack_public_path__ + "static/media/plus-branded.947ad791fc9bbe617b15090c65258710.svg";
export { ForwardRef as ReactComponent };